import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import {
    clientMutation,
    clientQuery,
} from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    location: null,
    error: null,
    contactId: null,
    customerId: null,
    create: null,
    update: null,
};

const route = "modules/workOrders/modals/createEditContact/redux/slice";

export const workOrderCreateContact = createAsyncThunk(
    "workOrders/workOrderCreateEditContact/createEntityContact",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              mutation (
                    $name: String!
                    $entityId: String!
                    $entityName: enumEntityName!
                    $phone: String
                    $email: String
                    $countryCode: String!
                    $notifyByPhone: Boolean!
                    $notifyByEmail: Boolean!
              ) {
                  data: createEntityContact (
                        name: $name
                        entityId: $entityId
                        entityName: $entityName
                        phone: $phone
                        email: $email
                        countryCode: $countryCode
                        notifyByPhone: $notifyByPhone
                        notifyByEmail: $notifyByEmail
                  ) {
                    id
                  }
              }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, "createWorkOrder");
            return rejectWithValue(exc);
        }
    }
);

export const workOrderEditContact = createAsyncThunk(
    "workOrders/workOrderCreateEditContact/updateEntityContact",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              mutation (
                    $id: Int!
                    $name: String
                    $phone: String
                    $email: String
                    $countryCode: String
                    $notifyByPhone: Boolean
                    $notifyByEmail: Boolean
                    $entityName: enumEntityName
              ) {
                  data: updateEntityContact (
                        id: $id
                        name: $name
                        phone: $phone
                        email: $email
                        entityName: $entityName
                        countryCode: $countryCode
                        notifyByPhone: $notifyByPhone
                        notifyByEmail: $notifyByEmail
                  ) {
                    id
                  }
              }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, "updateEntityContact");
            return rejectWithValue(exc);
        }
    }
);

export const workOrderGetContact = createAsyncThunk(
    "workOrders/workOrderCreateEditContact/getEntityContact",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              query ($id: Int!) {
                data: getEntityContact(id: $id) {
                    id
                    entityId
                    entityName
                    name
                    phone
                    email
                    notifyByPhone
                    notifyByEmail
                    countryCode
                }
            }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, "getEntityContact");
            return rejectWithValue(exc);
        }
    }
);

const workOrdersCreateEditContactRedux = createSlice({
    name: "workOrders/createEditContact",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        },
        openModalCreateEditContact(state, action) {
            state.open = true;
            state.contactId = action?.payload?.contactId;
            state.customerId = action?.payload?.customerId;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //workOrderCreateContact
        builder.addCase(workOrderCreateContact.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrderCreateContact.fulfilled, (state, action) => {
            state.loading = false;
            state.create = action.payload;
        });
        builder.addCase(workOrderCreateContact.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrderEditContact
        builder.addCase(workOrderEditContact.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrderEditContact.fulfilled, (state, action) => {
            state.loading = false;
            state.update = action.payload;
        });
        builder.addCase(workOrderEditContact.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrderGetContact
        builder.addCase(workOrderGetContact.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrderGetContact.fulfilled, (state, action) => {
            state.loading = false;
            state.contact = action.payload;
        });
        builder.addCase(workOrderGetContact.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersCreateEditContactRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalCreateEditContact,
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
